import "./PluginConfigPanel.0.css";
import ExprInput from "../../../../../lib/comps/ExprInput";
const __script_base__ = {
  name: 'PluginConfigPanel',
  components: {
    ExprInput
  },
  props: {
    plugin: {
      type: Object,
      default: () => null
    }
  },
  computed: {
    displayName() {
      if (this.plugin.global) {
        return `${this.plugin.name}[全局插件]`;
      }
      return this.plugin.name;
    },
    configValue: {
      get() {
        return this.plugin.data || '{}';
      },
      set(value) {
        this.$emit('change', value);
      }
    }
  }
};
var render = function () {
  var this$1 = this;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    staticClass: "ucd-eventCard"
  }, [_c("div", {
    staticClass: "ucd-eventCard-header"
  }, [_c("div", {
    staticClass: "ucd-eventCard-eventName",
    attrs: {
      title: _vm.plugin.name
    }
  }, [_vm._v("\n      " + _vm._s(_vm.displayName) + "\n    ")]), _vm._v(" "), !_vm.plugin.global ? _c("button", {
    staticClass: "uc-button ucd-eventCard-btn",
    on: {
      click: function ($event) {
        $event.preventDefault();
        return _vm.$emit("delete");
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-trash"
  }), _vm._v(" 删除\n    ")]) : _vm._e()]), _vm._v(" "), _c("div", {
    staticClass: "ucd-eventCard-content",
    staticStyle: {
      background: "#fff"
    }
  }, [_c("div", {
    staticClass: "ucd-pluginCard-cardContent"
  }, [_vm.plugin.global ? _c("a-alert", {
    staticStyle: {
      "margin-bottom": "16px"
    },
    attrs: {
      message: "如果配置了公共参数，此处的配置会将其覆盖",
      banner: ""
    }
  }) : _vm._e(), _vm._v(" "), _c("p", {
    staticClass: "ucd-pluginCard-cardContent-title"
  }, [_vm._v("\n        配置插件参数\n        "), _vm.plugin.desc ? _c("a-popover", {
    attrs: {
      title: "插件说明"
    }
  }, [_c("template", {
    slot: "content"
  }, [_c("p", {
    domProps: {
      innerHTML: _vm._s(_vm.plugin.desc)
    }
  })]), _vm._v(" "), _c("a-icon", {
    attrs: {
      type: "question-circle"
    }
  })], 2) : _vm._e()], 1), _vm._v(" "), _c("div", {
    staticStyle: {
      "margin-bottom": "16px"
    }
  }, [_c("ExprInput", {
    attrs: {
      value: _vm.configValue
    },
    on: {
      change: function (e) {
        return this$1.configValue = e;
      }
    }
  })], 1)], 1)])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "comps/PropPanel/EventPanel/PluginCardList/PluginConfigPanel.vue",
  "_scopeId": "data-v-73c8c930"
}, typeof __script__ === 'function' ? __script__.options : __script__);